<div class="column gap-lg center fill-vertical-horizontal background-grey-100">
  <span class="title">{{ 'VerticalSelectorComponent.loginTitle' | translate }}</span>
  <a class="text-btn" (click)="goToSelector()">
    <ion-icon name="chevron-back-outline"></ion-icon>
    {{ 'LoginComponent.backToSelector' | translate }}
  </a>
  <div class="column gap-lg">
    <div class="row center gap">
      <img class="loginLogo" [src]="currentCustomer?.logoUrlBase + 'login-logo.svg'" alt="EVA" />
      <span *ngIf="currentCustomer?.domain === securityDomain" class="text-md gap-sm center">{{
        currentCustomer?.name
      }}</span>
    </div>
    <mat-card class="column">
      <ng-login (logged)="redirect($event)"></ng-login>
    </mat-card>
  </div>
</div>
